const kollecAiIntegration = {
  generateApiKey: '/account/api/v1/generate_api_key/',
  uploadDataApi: '/kollectai/api/v1/etl/upload_data_api',
  integrationSampleFile: '/kollectai/api/v1/etl/sample_file',
};

export default kollecAiIntegration;
